import { render, staticRenderFns } from "./MainTour.vue?vue&type=template&id=35873091&scoped=true&"
import script from "./MainTour.vue?vue&type=script&lang=js&"
export * from "./MainTour.vue?vue&type=script&lang=js&"
import style0 from "./MainTour.vue?vue&type=style&index=0&id=35873091&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35873091",
  null
  
)

export default component.exports